function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFilledSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Arrow-sm open",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 804",
    style: {
      strokeWidth: 2,
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 13",
    transform: "translate(19.883 10.692)",
    style: {
      stroke: "#0025ff",
      strokeLinecap: "round",
      fill: "none",
      strokeWidth: 2
    },
    d: "M0 0v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2238.905 49.479 8.117 8.117 8.117-8.117",
    transform: "translate(-2227.139 -28.287)",
    style: {
      stroke: "#0025ff",
      strokeLinecap: "round",
      fill: "none",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFilledSm);
export default __webpack_public_path__ + "static/media/Arrow-filled-sm.b61e125ddb0d9ae7d19bba0384989866.svg";
export { ForwardRef as ReactComponent };